import React from 'react';

interface IProps {
    style?: any;
    fill?: string;
    width?: string;
    height?: string;
}

export const LockedIcon: React.FC<IProps> = (props: IProps) => {
    return (
        <svg width={props.width??"13"} height={props.height??"17"} viewBox="0 0 13 17" fill="none" xmlns="http://www.w3.org/2000/svg" style={props.style}>
        <path d="M12.0714 7.55556H11.1429V4.72222C11.1429 2.11461 9.06379 0 6.5 0C3.93621 0 1.85714 2.11461 1.85714 4.72222V7.55556H0.928571C0.417857 7.55556 0 7.98056 0 8.5V16.0556C0 16.575 0.417857 17 0.928571 17H12.0714C12.5821 17 13 16.575 13 16.0556V8.5C13 7.98056 12.5821 7.55556 12.0714 7.55556ZM3.71429 7.55556V4.72222C3.71429 3.15728 4.96136 1.88889 6.5 1.88889C8.03864 1.88889 9.28571 3.15728 9.28571 4.72222V7.55556H3.71429Z" fill={props.fill??"white"}/>
        </svg>        
    )
}

export default LockedIcon;